// Product page star rating redirect to reviews tab with loaded widget

(function () {
  function getReviewsTabLink() {
    // Find the REVIEWS tab link by its label (future-proof)
    const links = Array.from(document.querySelectorAll('a.tablink[href^="#tab"]'));
    return links.find(a => a.textContent.trim().toLowerCase() === 'reviews') || null;
  }

  function openReviewsTabAndFix() {
    const reviewsTab = getReviewsTabLink();
    if (!reviewsTab) return;

    const tabHash = reviewsTab.getAttribute('href'); // e.g. #tab5da1...
    if (!tabHash) return;

    // Force the theme to "fully" activate the tab by using its own hash + click
    if (location.hash !== tabHash) history.replaceState(null, '', tabHash);
    reviewsTab.click();

    // After animations/layout, scroll + refresh Judge.me
    setTimeout(() => {
      const widget = document.getElementById('judgeme_product_reviews');
      if (widget) widget.scrollIntoView({ behavior: 'smooth', block: 'start' });

      // Refresh Judge.me widgets once visible
      try {
        if (window.jdgm) {
          if (typeof window.jdgm.widgetRefresh === 'function') window.jdgm.widgetRefresh();
          if (typeof window.jdgm.refreshWidgets === 'function') window.jdgm.refreshWidgets();
        }
        if (typeof window.jdgmInitWidgets === 'function') window.jdgmInitWidgets();
      } catch (_) {}
    }, 700);
  }

  // 1) Intercept click on the star badge BEFORE other scripts
  document.addEventListener(
    'click',
    function (e) {
      const badge = e.target.closest('.jdgm-preview-badge');
      if (!badge) return;

      // Kill all default + other listeners that run after
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

      openReviewsTabAndFix();
    },
    true // capture phase = runs before Judge.me/theme handlers
  );

  // 2) If Judge.me changes hash to #judgeme_product_reviews, override it to the Reviews tab
  window.addEventListener('hashchange', function () {
    if (location.hash === '#judgeme_product_reviews') {
      // Replace with the theme's reviews tab hash and fully open it
      openReviewsTabAndFix();
    }
  });
})();

document.addEventListener('click', function (e) {
  const w = e.target.closest('.jdgm-all-reviews-text[data-link]');
  if (!w) return;
  window.location.href = w.getAttribute('data-link');
});

(function () {
  // =========================
  // CONFIG: set your base EUR price (no options selected)
  // =========================
  const BASE_EUR = 147.00; // <-- MUST be the base price in EUR (no options selected)

  // prevent double-run (CPB rerenders a lot)
  if (window.__cpb_labels_converted_once) {
    console.log("[CPB] already converted once, skipping");
    return;
  }

  function parseMoney(txt) {
    if (!txt) return null;
    const cleaned = txt.replace(/[^\d.,-]/g, "");
    const lastComma = cleaned.lastIndexOf(",");
    const lastDot = cleaned.lastIndexOf(".");
    let normalized = cleaned;

    if (lastComma > lastDot) normalized = cleaned.replace(/\./g, "").replace(",", ".");
    else normalized = cleaned.replace(/,/g, "");

    const val = Number(normalized);
    return Number.isFinite(val) ? val : null;
  }

  function getActiveCurrencyCode() {
    return window.Shopify?.currency?.active || null;
  }

  function getActiveSymbolFromText(txt) {
    const m = (txt || "").match(/[^0-9\s.,+-]/);
    return m ? m[0] : "";
  }

  function formatWithIntl(amount, currencyCode) {
    try {
      if (!currencyCode) return null;
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: currencyCode,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (e) {
      return null;
    }
  }

  function applyOnce() {
    const builder = document.querySelector("#product-builder");
    if (!builder) return false;

    const totalEl = builder.querySelector(
      '.cpb-product-full-price [data-testid="multycurrency-price"]'
    );
    if (!totalEl) return false;

    const totalTxt = (totalEl.textContent || "").trim();
    const baseActive = parseMoney(totalTxt);

    if (baseActive == null || baseActive <= 0) {
      console.log("[CPB] baseActive not ready yet:", totalTxt);
      return false;
    }

    const currencyCode = getActiveCurrencyCode();
    const symbol = getActiveSymbolFromText(totalTxt);

    const rate = baseActive / BASE_EUR;
    if (!Number.isFinite(rate) || rate <= 0) {
      console.log("[CPB] invalid rate", { baseActive, BASE_EUR, totalTxt });
      return false;
    }

    const priceSpans = builder.querySelectorAll(
      '.cpb-option-info-price [data-testid="multycurrency-price"]'
    );

    if (!priceSpans.length) {
      console.log("[CPB] no option price spans found yet");
      return false;
    }

    let convertedCount = 0;

    priceSpans.forEach((span) => {
      const raw = (span.textContent || "").trim();

      // ✅ only cache when we can parse a real number
      if (!span.dataset.cpbEur) {
        const eur = parseMoney(raw);
        if (eur == null || eur <= 0) return; // don't cache junk
        span.dataset.cpbEur = String(eur);
      }

      const eurVal = Number(span.dataset.cpbEur);
      if (!Number.isFinite(eurVal) || eurVal <= 0) return;

      const converted = eurVal * rate;

      const intl = formatWithIntl(converted, currencyCode);
      span.textContent = intl ? intl : `${symbol}${converted.toFixed(2)}`;
      convertedCount++;
    });

    if (convertedCount === 0) {
      console.log("[CPB] nothing converted yet (labels maybe not rendered/parsable)");
      return false;
    }

    window.__cpb_labels_converted_once = true;
    console.log("[CPB] ✅ Converted once", {
      rate,
      baseActive,
      BASE_EUR,
      currency: currencyCode || symbol,
      convertedCount
    });

    return true;
  }

  let tries = 0;
  const timer = setInterval(() => {
    tries++;
    if (applyOnce() || tries >= 60) clearInterval(timer);
  }, 200);
})();








